import { EntityType } from 'common/enums/entity-enums.js';
import { IObject } from 'common/interfaces/hierarchy-entities.js';


export const linkableTablesTypes: Partial<Record<EntityType, boolean>> = {
  [EntityType.WellboreWellheadPosition]: true,
  [EntityType.CoordinateReferenceSystem]: true,
  [EntityType.SiteReferenceSystem]: true,
};


export const isLinkableTable = (type: EntityType) =>  {
  return linkableTablesTypes[type] || false;
}

export const getIsLinked = (dataObject: IObject) => {
  const isLinkable = isLinkableTable(dataObject.type as EntityType);
  // leaving commented code in case if we need linkage logic back since its common solution for any entity
  // && (dataObject.metadata.isLinked || !dataObject.metadata.hasOwnProperty('isLinked'));
  return {
    isLinked: isLinkable,
    isLinkable,
  };
};